module.exports = __webpack_public_path__ + "static/media/whatsapp.2941fcfd.svg";